import { LeadsPage } from "../../features/leads";

export function AdminLeadsPage() {
  return <LeadsPage />;
}
